import { render, staticRenderFns } from "./PageModal.vue?vue&type=template&id=d596c172&scoped=true"
import script from "./PageModal.vue?vue&type=script&lang=js"
export * from "./PageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d596c172",
  null
  
)

export default component.exports